import { render, staticRenderFns } from "./tablestattr.vue?vue&type=template&id=3fd88eb4&"
import script from "./tablestattr.vue?vue&type=script&lang=js&"
export * from "./tablestattr.vue?vue&type=script&lang=js&"
import style0 from "./tablestattr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports